import { createSlice } from "@reduxjs/toolkit";
import { AppThunk } from "../../../app/store";
import { BillingReviewListState } from "../ShipmentReconciliationState";
import ShipmentReconciliationService from "../../../app/data/shipment-reconciliation/shipmentReconciliationService";
import { IState } from "../..";
import { BillingReviewWorkItemRequest } from "../../../app/data/shipment-reconciliation/models";

const initialState: BillingReviewListState = {
  requestStarted: false,
  fetchPortionStarted: false,
  requestCreator: "",
  requestSucceed: false,
  requestFailed: false,
  requestFailStatus: 0,
  requestError: "",
  hasNext: true,
  nextCursor: 0,
  shipmentWorkItems: []
};

const shipmentReconciliationService = ShipmentReconciliationService.getInstance();

export const getBillingReviewListSlice = createSlice({
  name: "getBillingReviewListSlice",
  initialState,
  reducers: {
    resetList: () => initialState,
    requestStarted: (state, { payload }) => {
      if (payload.requestCreator === "GET_BILLING_REVIEW_LIST_PORTION") {
        state.fetchPortionStarted = true;
      } else {
        state.requestStarted = true;
      }
      state.requestSucceed = false;
      state.requestFailed = false;
      state.requestCreator = payload;
      state.requestError = "";
    },
    requestSucceed: (state) => {
      state.requestStarted = false;
      state.fetchPortionStarted = false;
      state.requestSucceed = true;
      state.requestFailed = false;
    },
    requestFailed: (state, { payload }) => {
      state.requestStarted = false;
      state.fetchPortionStarted = false;
      state.requestSucceed = false;
      state.requestFailed = true;
      state.requestFailStatus = payload.status;
      state.requestError = payload.error;
    },
    setBillingReviewList: (state, { payload }) => {
      state.shipmentWorkItems = payload.shipmentWorkItems;
      state.nextCursor = (payload.nextCursor) ? payload.nextCursor : null;
      state.hasNext = (payload.nextCursor) ? true : false;
    },
    addBillingReviewList: (state, { payload }) => {
      state.shipmentWorkItems = [...state.shipmentWorkItems, ...payload.shipmentWorkItems];
      state.nextCursor = (payload.nextCursor) ? payload.nextCursor : null;
      state.hasNext = (payload.nextCursor) ? true : false;
    },
    changeBillingReviewListLocally: (state, { payload }) => {
      if (payload.shipmentWorkItems) state.shipmentWorkItems = payload.shipmentWorkItems;
    },
  },
});

export const {
  resetList,
  requestStarted,
  requestSucceed,
  requestFailed,
  setBillingReviewList,
  addBillingReviewList,
  changeBillingReviewListLocally
} = getBillingReviewListSlice.actions;

export const getBillingReviewListSelector = (state: IState) => state.billingReviewList;

export const getBillingReviewWorkItems = (
  requestData: BillingReviewWorkItemRequest,
  onError?: (error: string) => void,
): AppThunk => async (dispatch) => {
  dispatch(requestStarted({
    requestCreator: requestData.cursor ? "GET_BILLING_REVIEW_LIST_PORTION" : "GET_BILLING_REVIEW_LIST"
  }
  ));
  const response = await shipmentReconciliationService.getBillingReviewList(requestData);
  if (response.ok() && response.data) {
    dispatch(requestData.cursor ? addBillingReviewList(response.data) :  setBillingReviewList(response.data))
    dispatch(requestSucceed());
  } else {
    let error = "Internal Server Error, re-try the action or contact support";
    if (response && response.data && response.data.message) error = JSON.stringify(response.data.message);
    dispatch(requestFailed({
      status: response.status,
      error
    }));
    onError && onError(error)
  }
};

const getBillingReviewListReducer = getBillingReviewListSlice.reducer;
export default getBillingReviewListReducer;